
import {ICacheService} from './iCacheService';
import { ISessionService } from './sessions/sessionService';
import { UserInfoService } from '../features/userInfo/services/UserInfoService';
import { UserInfo } from '../features/userInfo/models/userInfo';

export class CacheService implements ICacheService {

    static $inject: string[] = ['UserInfoService', '$q'];

    constructor(private userInfoService: UserInfoService,
       private $q: ng.IQService) {
    }

    areCachesPopulated(): boolean {
        //console.log('areCachesPopulated');
        return this.userInfoService.isUserInfoPopulated();
    }

    populateCaches(): ng.IPromise<boolean> {
        const deferred = this.$q.defer<boolean>();

       
        const userInfoPromise = this.populateUserInfo();

        this.$q.all([userInfoPromise])
            .then(() => {
                this.$q.all([this.populateUserInfo()])
                    .then(() => {
                        deferred.resolve();
                    })
                    .catch((response) => {
                        deferred.reject(this.getErrorReason(response.status));
                    });
            })
            .catch((response) => {
                console.error(response);
                deferred.reject(this.getErrorReason(response.status));
            });

        return deferred.promise;
    }

   private populateUserInfo(): ng.IPromise<UserInfo> {
        const deferred = this.$q.defer<UserInfo>();
       this.userInfoService.loadUserInfo()
           .then(() => {
               deferred.resolve();
           })
           .catch((response) => {
               deferred.reject(response);
           });
        return deferred.promise;
    }

   
    private getErrorReason(status: number): string {
        var value = 'error';
        if (status === 401)
            value = 'timeout';
        return value;
    }

    
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/cacheService.ts
 **/